/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/destructuring-assignment */
import 'rc-notification/assets/index.css';
import React, { useRef, Component } from "react";
import { Row, Col, } from 'reactstrap';
import Notification from 'rc-notification';
import { Table, Button, Popconfirm, Upload } from "antd";
import * as XLSX from 'xlsx';
import SmallLoader from '../../../shared/components/SmallLoader';
import history from '../../App/History';
import ProductResizableTable from './ProductResizableTable';
import { tableHeaderDataForUploadProduct as tableHeaderData } from "../helper";

export default class ExcelImport extends Component {  
  constructor(props) {  
    
    super(props);
    this.input = React.createRef(); 
    this.tableData = { tableHeaderData: [], tableRowsData: [] };
    this.isEmptyCell = false;
    this.isError = false;
    this.errorMessage = '';
    this.cogsNumberCount = 0;
    this.emptyCellCount = 0;
    this.emptyCellErrorMessage = '';
    this.cogsErrorMessage = '';
    this.state = {
      cols: [],
      rows: [],
      isLoading: false,
      regexp: /^\$?[0-9.,]+$/,
      errorMessage: null,
      columns: [
        {
          title: "SKU",
          dataIndex: "key",
          editable: true,
          width: 180
        },
        {
          title: "Title",
          dataIndex: "prouctName",
          editable: true,
          width: 220
        },        
        {
          title: "Collection",
          dataIndex: "productCollection",
          editable: true,
          width: 200
        },
        {
          title: "Category",
          dataIndex: "productCategory",
          editable: true,
          width: 200
        },
        {
          title: "SubCategory",
          dataIndex: "productSubCategory",
          editable: true,
          width: 200
        },   
        {
          title: "Cogs",
          dataIndex: "cogs",
          editable: true,
          width: 200
        }
      ]
    };
  }  

  handleSave = (row) => {
    const newData = [...this.state.rows];
    const index = newData.findIndex(item => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row
    });
    this.setState({ rows: newData });
  };

  clearData = () => {
    this.setState({ rows: [] })
    this.input.current.value = ""
  }

  // Updated Excel import function using XLSX
  onImportExcel = (event) => {
    const { files } = event.target;
    
    if (files.length === 1) {
      // Check file type
      if (!(files[0].type === "application/vnd.ms-excel" || 
      files[0].type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) 
      {
        Notification.newInstance({}, (notification) => {
          notification.notice({
            content: 'Unknown file format. Only Excel files are uploaded!',
            duration: 5,
            closable: true,
            style: {top: 120, fontWeight: "bold"},
            maxCount: 50
          });
        }); 
        this.setState({
          errorMessage: "Unknown file format. Only Excel files are uploaded!"
        });      
        return false;
      }

      // Read file using XLSX
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          
          // Get first worksheet
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          
          // Convert to JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          
          if (jsonData.length < 2) {
            Notification.newInstance({}, (notification) => {
              notification.notice({
                content: 'No data found in file!',
                duration: 10,
                style: {top: 120, fontWeight: "bold"},
                maxCount: 50
              });
            });
            return;
          }

          const newRows = [];
          
          // Reset error tracking
          this.isError = false;
          this.cogsNumberCount = 0;
          this.cogsErrorMessage = '';
          
          // Process data rows (skip header row)
          jsonData.slice(1).forEach((row, index) => {
            if (row && row.length > 0) {
              // Helper function to safely convert values to string
              const safeString = (value) => {
                if (value === null || value === undefined || value === '') {
                  return '';
                }
                return String(value);
              };

              // Check if row has any data in the first 5 columns
              if (row[0] !== undefined || row[1] !== undefined ||
                  row[2] !== undefined || row[3] !== undefined || 
                  row[4] !== undefined) {
                
                // Validate COGS field (column 5)
                let cogsValue = '0';
                if (row[5] !== undefined) {
                  const rawCogs = safeString(row[5]);
                  if (this.state.regexp.test(rawCogs)) {
                    // Remove $ and , from the cogs value
                    cogsValue = rawCogs.replace(/\$|,/g, '');
                  } else {
                    // Invalid COGS format - set error
                    this.isError = true;
                    if (this.cogsNumberCount === 0) {
                      this.cogsErrorMessage = `Invalid COGS format in row ${index + 2}. Only numbers, $ and , are allowed.`;
                      this.cogsNumberCount += 1;
                    }
                    cogsValue = '0'; // Default to 0 for invalid values
                  }
                }

                newRows.push({
                  key: safeString(row[0]),
                  prouctName: safeString(row[1]),                             
                  productCollection: safeString(row[2]),
                  productCategory: safeString(row[3]),
                  productSubCategory: safeString(row[4]),
                  cogs: cogsValue
                });
              }
            }
          });

          // Show error notification if there were validation issues
          if (this.isError === true) {
            this.errorMessage = this.cogsErrorMessage;
            Notification.newInstance({}, (notification) => {
              notification.notice({
                content: <span>{this.errorMessage}</span>,
                duration: 10,
                onClose() {
                  console.log('closable close');
                },
                closable: true,
                onClick() {
                  console.log('clicked!!!');
                },
                style: {top: 120, fontWeight: "bold"},
              });
            }); 
          } else {
            this.isError = false;
            this.isEmptyCell = false;
          }

          if (newRows.length === 0) {
            Notification.newInstance({}, (notification) => {
              notification.notice({
                content: 'No data found in file!',
                duration: 10,
                style: {top: 120, fontWeight: "bold"},
                maxCount: 50
              });
            });            
          } else {
            this.setState({
              cols: jsonData[0] || [], // Headers
              rows: newRows,
              errorMessage: null
            });
          }
          
        } catch (error) {
          console.error('Error reading file:', error);
          Notification.newInstance({}, (notification) => {
            notification.notice({
              content: 'Error reading file. Please check file format.',
              duration: 10,
              style: {top: 120, fontWeight: "bold"},
              maxCount: 50
            });
          });
        }
      };
      
      reader.readAsArrayBuffer(files[0]);
    } else {
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'No file uploaded!',
          duration: 10,
          style: {top: 120, fontWeight: "bold"},
          maxCount: 50
        });
      });
      this.setState({
        errorMessage: "No file uploaded!"
      });
      return false;
    }
    return false;
  }; 

  handleSubmit = async () => {
    this.setState({ isLoading: true });
    console.log("submitting: ", this.state.rows);
    
    const token = localStorage.getItem('easydev');
    const requestOptions = {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        Authorization: token 
      },
      body: JSON.stringify(this.state.rows)
    };
    
    try {
      const response = await fetch('https://rss.getrael.com/api/product/update', requestOptions);
      const data = await response.json();
      
      if (data.code === '200') {
        this.setState({ isLoading: false });
        history.push('/products');
      } else if (data.code === '403') {
        this.setState({ isLoading: false });
        history.push('/login');
      } else {
        this.setState({ isLoading: false });
        Notification.newInstance({}, (notification) => {
          notification.notice({
            content: 'Products not uploaded, Please try again!',
            duration: 10,
            style: {top: 120, fontWeight: "bold"},
            maxCount: 50
          });
        });
        console.log("Products not uploaded, Please try again!");
      }
    } catch (error) {
      this.setState({ isLoading: false });
      console.error('Error submitting data:', error);
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'Error submitting data. Please try again!',
          duration: 10,
          style: {top: 120, fontWeight: "bold"},
          maxCount: 50
        });
      });
    }
  };

  handleDelete = (key) => {
    const rows = [...this.state.rows];
    this.setState({ rows: rows.filter(item => item.key !== key) });
  };

  handleAdd = () => {
    const { count, rows } = this.state;
    const newData = {
      key: count,
      name: "User's name",
      age: "22",
      gender: "Female"
    };
    this.setState({
      rows: [newData, ...rows],
      count: count + 1
    });
  };

  render() {
    const components = {
      body: {
      }
    };
    const columns = this.state.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave
        })
      };
    });
    
    return (
      <>
      <Col md={12}>      
        <Row>             
          <Col md="6">
            <input 
              className="file-uploader" 
              type="file" 
              accept=".xlsx, .xls" 
              onChange={this.onImportExcel} 
              ref={this.input} 
            />
            &nbsp;<Button 
              className="btn btn-sm btn-danger"
              style={{ marginTop: 16 }}
              onClick={this.clearData}
            >            
              &nbsp;Clear
            </Button> 
          </Col>
          <Col md="6" align="right">
            {this.state.rows.length > 0 && (
              <>               
                <Button
                  onClick={this.handleSubmit}
                  size="large"
                  type="primary"
                  className="btn btn-primary btn-sm"
                  disabled={this.isEmptyCell}
                  style={{ marginBottom: 16, marginLeft: 10, marginTop: 16 }}
                >
                  Submit Data
                </Button>
              </>
            )}
            <Button
              onClick={() => history.push('/products')}
              size="large"
              type="danger"
              className="btn btn-primary btn-sm"
              style={{ marginBottom: 16, marginLeft: 10, marginTop: 16 }}
            >
             Back To Product
            </Button>
          </Col>       
        </Row>
        <Row>
          <Col md={12} lg={12}>
            {this.state.isLoading ? (
              <>                 
                <div
                  style={{ minHeight: '200px' }}
                  className="row align-items-center justify-content-center"
                >
                  <SmallLoader loading={this.state.isLoading} />
                </div>
              </>
            ) : (
              <ProductResizableTable 
                customClass="pt-0" 
                reactTableData={{tableHeaderData}} 
                data={this.state.rows} 
              />
            )}
          </Col>
        </Row>       
      </Col>
      </>
    );
  }
}